<template>
  <div>
    <div class="elasticBlockStoreResourceAli-title">
      <div>{{ $t("RAM.AWS.ElasticBlockStorage.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticBlockStoreResourceAli:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticBlockStoreResourceAli:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticBlockStoreResourceAli-top">
      <elastic-block-store-resource-search
        ref="elasticBlockStoreResourceSearchChild"
      ></elastic-block-store-resource-search>
    </div>
    <table-elastic-block-store-resource></table-elastic-block-store-resource>
  </div>
</template>

<script>
import ElasticBlockStoreResourceSearch from "../ebs/ElasticBlockStoreResourceSearch";
import TableElasticBlockStoreResource from "../ebs/TableElasticBlockStoreResource";

export default {
  name: "ElasticBlockStoreResourceAli",
  components: {
    ElasticBlockStoreResourceSearch,
    TableElasticBlockStoreResource
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.elasticBlockStoreResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 3,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.elasticBlockStoreResourceSearchChild.accountNameSearchKey;
      this.companyId = this.$refs.elasticBlockStoreResourceSearchChild.companyId;

      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliVolume({
          // "accountName": this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "弹性块存储.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.elasticBlockStoreResourceAli-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticBlockStoreResourceAli-title > div:nth-child(1) {
  float: left;
}
.elasticBlockStoreResourceAli-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticBlockStoreResourceAli-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ebs/ElasticBlockStoreResourceAli.vue